import React from 'react';
import { Path } from 'svgs';
import { createIcon } from '../createIcon';

const vectorComponent = () => (
  <>
    <Path
      d="M12 20.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17z"
      strokeMiterlimit={10}
    />
    <Path
      d="M12 7.5v6M12 15.5v.5"
      strokeWidth={1.2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </>
);

export const ErrorIcon = createIcon({ viewBox: '3 3 18 18', vectorComponent });
